





















import SfSelectOption from '@storefront-ui/vue/src/components/molecules/SfSelect/_internal/SfSelectOption.vue';
import {
  defineComponent,
  ref,
  toRef,
  computed,
} from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import Select from '~/components/atoms/Inputs/Select/Select.vue';
import { REVIEW_SORTING_OPTIONS } from '~/constants/reviewSortingOptions';
import { useReviewExtended } from '~/composables';
import { usePagination } from '~/composables/usePagination';
import getSortParamsFromString from '~/helpers/getSortParamsFromString';
import {
  DEFAULT_REVIEWS_SEARCH_PARAMS,
  PAGINATION_DEFAULT_RESULTS_LIMIT,
} from '~/constants/pagination';

export default defineComponent({
  name: 'SortingReviews',
  components: {
    SfSelectOption,
    Select,
  },
  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const productIdRef = toRef(props, 'productId');

    const {
      search: searchReviews,
      updateSortParams,
    } = useReviewExtended(productIdRef);

    const {
      resetPaginationPage,
    } = usePagination(props.totalResultsAmount, props.perPage);

    const { i18n } = useVSFContext();

    const localizedSortingOptions = computed(() => {
      return REVIEW_SORTING_OPTIONS.map((option) => {
        return {
          value: option.value,
          name: i18n.t(option.name),
        };
      });
    });

    const sortOption = ref(localizedSortingOptions.value[0].value);

    const sortReviews = () => {
      const sort = getSortParamsFromString(sortOption.value);
      updateSortParams(sort);
      const paginationParams = {
        offset: DEFAULT_REVIEWS_SEARCH_PARAMS.offset,
        limit: DEFAULT_REVIEWS_SEARCH_PARAMS.limit,
      };
      resetPaginationPage();
      searchReviews(paginationParams);
    };

    return {
      sortReviews,
      sortOption,
      REVIEW_SORTING_OPTIONS,
      localizedSortingOptions,
    };
  },
});
